/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecureIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import NotSecure from './NotSecure/index'
import React from 'react'
import Secure from './Secure/index'



/** @type {import('Simple/types.js').View} */
export default function SecureIndicator({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/Secure/InApp/SecureIndicator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Secure'
let messageComposeIsSecureValueData = fromData.useDataFormat({ viewPath,
context: 'message_compose',
path: 'is_secure',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: messageComposeIsSecureValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Secure'}>
<Secure
  viewPath={`${viewPath}/Secure`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotSecure'}>
<NotSecure
  viewPath={`${viewPath}/NotSecure`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}